import firebase from "firebase";

export default {
  namespaced: true,

  state: {
    // ユーザー情報
    user: {},
    // 全ユーザー情報
    users: []
  },

  mutations: {
    // state内のfriendStatusを更新します.
    updateUsersFriendStatus(state: any, updateUsersFriendStatusInfo: any) {
      state.users.some((user: any) => {
        if (user.userId === updateUsersFriendStatusInfo.userId) {
          user.userFriends.some((friend: any) => {
            if (friend.friendUserId === updateUsersFriendStatusInfo.loginUserId) {
              friend.friendStatus = updateUsersFriendStatusInfo.friendStatus;
              return true;
            }
          });
          return true;
        }
      });
    },
    // ユーザー情報を取得します.
    fetchOtherUser(state: any, user: any) {
      state.user = [];
      state.user = user;
    },
    // 全ユーザー情報を取得します.
    addUser(state: any, user: any) {
      state.users.push(user);
    },
    // 全ユーザー情報を削除します.
    resetUsers(state: any) {
      state.users = [];
    }
  },

  actions: {
    // ユーザー情報を取得します.
    fetchOtherUser({ commit }: any, userId: string) {
      const userDb = firebase
        .firestore()
        .collection("users")
        .doc(userId);
      const promises: any = [];
      userDb.get().then(userDoc => {
        const user: any = userDoc.data();
        const userFriends: any = [];
        const friendQueryPromise = userDb
          .collection("friends")
          .get()
          .then(friendSnapShot => {
            friendSnapShot.forEach(friendDoc => {
              userFriends.push(friendDoc.data());
            });
            promises.push(friendQueryPromise);
          });
        user.userFriends = userFriends;
        const userGroups: any = [];
        const groupQueryPromise = userDb
          .collection("groups")
          .get()
          .then(groupSnapShot => {
            groupSnapShot.forEach(groupDoc => {
              userGroups.push(groupDoc.data());
            });
            promises.push(groupQueryPromise);
          });
        user.userGroups = userGroups;
        const userJobs: any = [];
        const jobQueryPromise = userDb
          .collection("jobs")
          .get()
          .then(jobSnapShot => {
            jobSnapShot.forEach(jobDoc => {
              userJobs.push(jobDoc.data());
            });
            promises.push(jobQueryPromise);
          });
        user.userJobs = userJobs;
        commit("fetchOtherUser", user);
      });
      return Promise.all(promises);
    },
    // 全ユーザー情報を取得します.
    fetchUsers({ commit }: any) {
      commit("resetUsers");
      const usersRef = firebase.firestore().collection("users");
      return usersRef
        .orderBy("userName")
        .get()
        .then(querySnapshot => {
          let promise;
          querySnapshot.forEach(doc => {
            const user = doc.data();
            const userFriends: any = [];
            promise = usersRef
              .doc(user.userId)
              .collection("friends")
              .get()
              .then(querySnapshot =>
                querySnapshot.forEach(doc => {
                  userFriends.push(doc.data());
                  user.userFriends = userFriends;
                })
              );
            commit("addUser", user);
          });
          return Promise.resolve(promise);
        });
    },
    // ユーザーに対して退会処理を行います.
    deleteUser({ rootGetters }: any) {
      let successStatus = true;
      const db = firebase.firestore();
      const currentUser = firebase.auth().currentUser;
      if (currentUser !== null) {
        if (currentUser.uid === rootGetters.loginUserId) {
          //対象userドキュメント内のサブコレクションを削除
          const userDocRef = db.collection("users").doc(rootGetters.loginUserId);
          // friendsコレクション内のドキュメントを削除
          const usersFriendDb = userDocRef.collection("friends");
          usersFriendDb.get().then(friendSnapShot => {
            friendSnapShot.forEach(friendDoc => {
              usersFriendDb
                .doc(friendDoc.data().friendUserId)
                .delete()
                .catch(error => {
                  successStatus = false;
                  console.log("(friendDoc.data().friendUserId).delete().catch((error)): ", friendDoc.data().friendUserId, error.message);
                });
            });
          });
          // groupsコレクション内のドキュメントを削除
          const usersGroupDb = userDocRef.collection("groups");
          usersGroupDb.get().then(groupSnapShot => {
            groupSnapShot.forEach(groupDoc => {
              usersGroupDb
                .doc(groupDoc.data().groupId)
                .delete()
                .catch(error => {
                  successStatus = false;
                  console.log("(groupDoc.data().groupId).delete().catch((error)): ", groupDoc.data().groupId, error.message);
                });
            });
          });
          // jobsコレクション内のドキュメントを削除
          const usersJobDb = userDocRef.collection("jobs");
          usersJobDb.get().then(jobSnapShot => {
            jobSnapShot.forEach(jobDoc => {
              usersJobDb
                .doc(jobDoc.data().jobId)
                .delete()
                .catch(error => {
                  successStatus = false;
                  console.log("(jobDoc.data().jobId).delete().catch((error)): ", jobDoc.data().jobId, error.message);
                });
            });
          });
          // 対象userドキュメントを削除
          userDocRef.delete().catch(error => {
            successStatus = false;
            console.log("userDocRef.delete().catch((error)): ", error.message);
          });
          // 各コレクションの関連データを全て削除
          // jobsコレクション
          const jobDb = db.collection("jobs");
          jobDb
            .where("userId", "==", rootGetters.loginUserId)
            .get()
            .then(jobSnapShot => {
              jobSnapShot.forEach(jobDoc => {
                const jobsMemberDb = jobDb.doc(jobDoc.data().jobId).collection("members");
                jobsMemberDb.get().then(jobsMemberSnapShot => {
                  jobsMemberSnapShot.forEach(jobsMemberDoc => {
                    jobsMemberDb.doc(jobsMemberDoc.data().userId).delete();
                  });
                });
              });
            });
          // recordsコレクション
          const recordDb = db.collection("records");
          recordDb.get().then(recordSnapShot => {
            recordSnapShot.forEach(recordDoc => {
              const recordCommentDb = recordDb.doc(recordDoc.data().recordId).collection("comments");
              const recordLikeDb = recordDb.doc(recordDoc.data().recordId).collection("likes");
              if (recordDoc.data().userId === rootGetters.loginUserId) {
                const promise = recordCommentDb.get().then(recordCommentSnapShot => {
                  recordCommentSnapShot.forEach(recordCommentDoc => {
                    recordCommentDb.doc(recordCommentDoc.data().commentId).delete();
                  });
                });
                const promise2 = recordLikeDb.get().then(recordLikeSnapShot => {
                  recordLikeSnapShot.forEach(recordLikeDoc => {
                    recordLikeDb.doc(recordLikeDoc.data().likeId).delete();
                  });
                });
                Promise.all([promise, promise2]).then(() => {
                  recordDb.doc(recordDoc.data().recordId).delete();
                });
              } else {
                console.log("recordDoc.data().userId: ", recordDoc.data().userId, "rootGetters.loginUserId: ", rootGetters.loginUserId);
                recordCommentDb
                  .where("commentUserId", "==", rootGetters.loginUserId)
                  .get()
                  .then(recordCommentSnapShot => {
                    recordCommentSnapShot.forEach(recordCommentDoc => {
                      console.log("recordCommentDoc.data().commentId: ", recordCommentDoc.data().commentId);
                      recordCommentDb.doc(recordCommentDoc.data().commentId).delete();
                    });
                  });
                recordLikeDb
                  .where("likeUserId", "==", rootGetters.loginUserId)
                  .get()
                  .then(recordLikeSnapShot => {
                    recordLikeSnapShot.forEach(recordLikeDoc => {
                      console.log("recordLikeDoc.data().likeId: ", recordLikeDoc.data().likeId);
                      recordLikeDb.doc(recordLikeDoc.data().likeId).delete();
                    });
                  });
              }
            });
          });
          // groupsコレクション
          const groupDb = db.collection("groups");
          groupDb.get().then(groupSnapShot => {
            groupSnapShot.forEach(groupDoc => {
              const groupChatDb = groupDb.doc(groupDoc.data().groupId).collection("chats");
              const groupJobDb = groupDb.doc(groupDoc.data().groupId).collection("jobs");
              const promise = groupDb
                .doc(groupDoc.data().groupId)
                .collection("members")
                .doc(rootGetters.loginUserId)
                .delete();
              const promise2 = groupChatDb
                .where("userId", "==", rootGetters.loginUserId)
                .get()
                .then(groupsChatSnapShot => {
                  groupsChatSnapShot.forEach(groupsChatDoc => {
                    groupChatDb.doc(groupsChatDoc.data().groupChatId).delete();
                  });
                });
              Promise.all([promise, promise2]).then(() => {
                if (groupDoc.data().groupLeaderUserId === rootGetters.loginUserId) {
                  groupJobDb
                    .get()
                    .then(groupJobSnapShot => {
                      groupJobSnapShot.forEach(groupJobDoc => {
                        groupJobDb.doc(groupJobDoc.data().jobId).delete();
                      });
                    })
                    .then(() => {
                      groupDb.doc(groupDoc.data().groupId).delete();
                    });
                }
              });
            });
          });
          // usersコレクション
          const userDb = db.collection("users");
          userDb.get().then(userSnapShot => {
            userSnapShot.forEach(userDoc => {
              userDb
                .doc(userDoc.data().userId)
                .collection("friends")
                .doc(rootGetters.loginUserId)
                .delete();
            });
          });
        } else {
          successStatus = false;
          console.log("currentUser.uid !== rootGetters.loginUserId\ncurrentUser.uid: ", currentUser.uid, "\nrootGetters.userId", rootGetters.loginUserId);
        }
        if (successStatus) {
          // FirebaseのAuthenticationに登録されている対象ユーザー情報を削除
          currentUser
            .delete()
            .then(() => {
              alert("退会処理に成功しました\nまたのご登録をお待ちしております！");
            })
            .catch(error => {
              alert("退会処理に失敗しました");
              console.log("currentUser.delete().catch((error): ", error.message);
            });
        }
      } else {
        alert("退会処理に失敗しました");
        console.log("currentUser === null\ncurrentUser: ", currentUser);
      }
    },
    // state内のfriendStatusを更新します.
    updateUsersFriendStatus({ commit, rootGetters }: any, { friendStatus, otherUserId }: any) {
      const updateUsersFriendStatusInfo = {
        friendStatus: friendStatus,
        loginUserId: rootGetters.loginUserId,
        userId: otherUserId
      };
      commit("updateUsersFriendStatus", updateUsersFriendStatusInfo);
    }
  },

  getters: {
    // ユーザー情報
    otherUser: (state: any) => (state.user ? state.user : ""),
    // 全ユーザー情報
    users: (state: any) => (state.users ? state.users : "")
  }
};
